import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowTopRight2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowTopRight2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H10V5H5V19H19V14H21V21H3V3ZM13 3H21V11H19V6.41421L11 14.4142L9.58579 13L17.5858 5H13V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowTopRight2;
